import * as actionTypes from "../mutation-types";
import _ from "lodash";
import {AUTH_FLOW_METHODS} from "../../libraries/globalTemplateSpecific/bm100/utils";

// initial state
const state = {
	persistedData: {},
	tempData: {},
	editModeData: null,
	userEditMode: false,
	isPersisted: false,
	loginHistory: false,
	isFirstLogin: false,
	authFlow: ""
};

// getters
const getters = {
	getUserDataDebug: state => {
		return {
			editModeData: state.editModeData,
			isPersisted: state.isPersisted,
			persistedData: state.persistedData,
			tempData: state.tempData
		};
	},
	getUserData: state => {
		if (state.editModeData) {
			return state.editModeData;
		} else {
			const type = state.isPersisted ? "persistedData": "tempData";
			return state[type];
		}
	},
	getUserDataIsPersisted: state => state.editModeData ? false: state.isPersisted,
	getLoginHistory: state => state.loginHistory,
	isFirstLogin: state => state.isFirstLogin,
	getAuthFlow: state => state.authFlow // normal, history, cart, popup
};

// actions
const actions = {
	[actionTypes.USER_DATA_SET]: ({ commit }, userData) => {
		return new Promise(function(resolve) {
			commit(actionTypes.USER_DATA_SET, userData);
			resolve();
		});
	},

	[actionTypes.REMOVE_USER_DATA]: ({ commit }) => {
		return new Promise(function(resolve) {
			commit(actionTypes.REMOVE_USER_DATA);
			resolve();
		});
	},

	[actionTypes.USER_DATA_PERSIST_TOGGLE]: ({ commit }, persistUserData) => {
		return new Promise(function(resolve) {
			commit(actionTypes.USER_DATA_PERSIST_TOGGLE, persistUserData);
			resolve();
		});
	}
};

// mutations
const mutations = {
	[actionTypes.USER_DATA_SET] (state, userData) {
		if (state.userEditMode) {
			state.editModeData = _.extend(state.editModeData, userData);
		} else {
			const type = state.isPersisted ? "persistedData": "tempData";
			state[type] = _.extend(state[type], userData);
		}
		if(userData && userData.isAppUser) {
			state.loginHistory = true;
		}
	},

	[actionTypes.REMOVE_USER_DATA] (state) {
		state.editModeData = null;
		state["persistedData"] = {};
		state["tempData"] = {};
	},

	[actionTypes.USER_DATA_PERSIST_TOGGLE] (state, persistUserData) {
		state.isPersisted = persistUserData;

		if (persistUserData) {
			state.persistedData = state.tempData;
			state.tempData = {};
		} else {
			state.tempData = state.persistedData;
			state.persistedData = {};
		}
	},

	[actionTypes.ENABLE_USER_EDIT_MODE] (state, userData) {
		state.editModeData = _.extend(state.editModeData, userData);
		state.userEditMode = true;
	},

	[actionTypes.DISABLE_USER_EDIT_MODE] (state) {
		state.editModeData = null;
		state.userEditMode = false;
	},

	[actionTypes.REMEMBER_LOGIN_HISTORY] (state, value) {
		state.loginHistory = value;
	},
	[actionTypes.FIRST_LOGIN_SET] (state, value) {
		state.isFirstLogin = value;
	},
	[actionTypes.SET_AUTH_FLOW_TRACKING] (state, value = AUTH_FLOW_METHODS.NORMAL) {
		state.authFlow = value;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
